import { render, staticRenderFns } from "./GoogleReview.vue?vue&type=template&id=3c3cbb06&scoped=true&"
import script from "./GoogleReview.vue?vue&type=script&lang=js&"
export * from "./GoogleReview.vue?vue&type=script&lang=js&"
import style0 from "./GoogleReview.vue?vue&type=style&index=0&id=3c3cbb06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3cbb06",
  null
  
)

export default component.exports